import { hideLoading, showLoading } from 'react-redux-loading-bar';

import api from '../../utils/api/api';

import { SET_IS_PRELOAD } from '../../utils/common/constant';
import { setAuthUserActionCreator } from '../authUser/action';

const ActionType = {
  SET_IS_PRELOAD,
};

const setIsPreloadActionCreator = (isPreload) => {
  return {
    type: ActionType.SET_IS_PRELOAD,
    payload: {
      isPreload,
    },
  };
};

const asyncPreloadProcess = () => {
  return async (dispatch) => {
    dispatch(showLoading());

    try {
      const authUser = await api.getUserLogged();
      dispatch(setAuthUserActionCreator(authUser));
    } catch (error) {
      dispatch(hideLoading());
      dispatch(setAuthUserActionCreator(null));
    } finally {
      dispatch(hideLoading());
      dispatch(setIsPreloadActionCreator(false));
    }

    dispatch(hideLoading());
  };
};

export {
  ActionType,
  setIsPreloadActionCreator,
  asyncPreloadProcess,
};
